// 手机查路线——百度地图，主流程
const bdMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `line/bd/index${i + 1}`,
  name: `lineBdIndex${i + 1}`,
  component: () => import(`@/views/traffic/line/bd/index${i + 1}.vue`)
}))

// 手机查路线——高德地图，主流程
const gdMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `line/gd/index${i + 1}`,
  name: `lineGdIndex${i + 1}`,
  component: () => import(`@/views/traffic/line/gd/index${i + 1}.vue`)
}))

export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机查路线——百度地图，开始
    ...bdMainRoutes,

    // 手机查路线——高德地图，主流程
    ...gdMainRoutes,
  ],
};
